<template>
  <div>
    <el-card ref="card">
      <template v-if="active">
        <div class="cert-box">
          <!-- 证书标题 -->
          <div class="cert-title">
            <h2>精液生化免疫与精子功能室间质评（EQA）证书</h2>
            <div class="logo-line">
              <img src="../../../assets/EQA_logo.png" />
              <div class="line"></div>
            </div>
          </div>
          <!-- 参评实验室名称 -->
          <div class="cert-name">
            <p>
              <span class="lab-name">{{ userForm.laboratoryName }}</span>
              :
            </p>
          </div>
          <!-- 证书正文 -->
          <div class="cert-body">
            <p>
              贵单位参加深圳市临床检验质量控制中心与深圳市人民医院生殖医学中心组织的
              <span class="year-text">{{ year }}</span>
              年度精液生化免疫与精子功能外部质量控制实践，总体成绩
              <span class="level">{{ userForm.totalLevel }}</span>。
            </p>
          </div>
          <!-- 参评项目与成绩细则 -->
          <div class="cert-detail">
            <div class="detail-title">参评项目与成绩细则：</div>
            <div class="detail-list">
              <p v-for="item in prodList" :key="item.prodName">
                {{ item.prodName }}PT(%): {{ item.prodScore }}
              </p>
            </div>
          </div>
          <!-- 盖章图片与单位名称 -->
          <div class="seal-area">
            <div class="seal-name">
              <p v-for="(item, index) in centreList" :key="index">
                {{ item.paramValue }}
              </p>
            </div>
            <div class="seal-img" :class="'seal' + sealCount">
              <div
                class="seal_inner"
                v-for="(item, index) in sealList"
                :key="index"
              >
                <img :src="item.remark" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="empty-tip" v-else>
        <i class="el-icon-info"></i>
        <p>亲爱的用户，{{ year }}年年度成绩还未生成，请稍后再来查看。</p>
      </div>
    </el-card>
    <el-button type="primary" v-if="active" @click="exportPDF">导出PDF</el-button>
    <el-button type="primary" v-if="active" @click="Print">打印预览</el-button>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import JsPDF from "jspdf";
import printJS from "print-js";
export default {
  data() {
    return {
      active: false,
      year: "",
      mobile: "",
      prodList: [],
      userForm: {},
      paramKey: "",
      centreList: [],
    };
  },
  computed: {
    // 有盖章图片的中心列表
    sealList() {
      return this.centreList.filter((item) => {
        return item.remark;
      });
    },
    // 盖章图片数量（超过3个按3个处理）
    sealCount() {
      const count = this.sealList.length;
      return count > 3 ? 3 : count;
    },
  },
  created() {
    this.year = this.$route.query.year;
    this.mobile = window.sessionStorage.getItem("phone");
    this.getUserYearResult();
    this.getUserCentre();
  },
  methods: {
    // 获取当前用户年度成绩
    async getUserYearResult() {
      let res;
      try {
        const resp = await this.$http.post(
          "quality/data/yearResult/user",
          {
            year: this.year,
            mobile: this.mobile,
          }
        );
        res = resp && resp.data;
      } catch (e) {
        res = null;
      }
      if (!res || res.code != 200) {
        // 数据不存在时展示友好提示，不弹错误框
        this.active = false;
        return;
      }
      this.active = true;
      this.userForm = res.data;
      this.prodList = res.data.prodInfoList || [];
    },
    // 获取证书标题及盖章图片（下半年优先，其次上半年）
    async getUserCentre() {
      let res;
      try {
        const resp = await this.$http.post("sysConfig/selectByFirstKey", {
          year: this.year,
          quarter: "下半年",
          firstKey: "qe_centre",
        });
        res = resp && resp.data;
      } catch (e) {
        res = null;
      }
      if (!res || res.code != 200 || !res.data || res.data.length === 0) {
        try {
          const resp2 = await this.$http.post("sysConfig/selectByFirstKey", {
            year: this.year,
            quarter: "上半年",
            firstKey: "qe_centre",
          });
          res = resp2 && resp2.data;
        } catch (e) {
          res = null;
        }
      }
      if (!res || res.code != 200 || !res.data || res.data.length === 0) {
        return;
      }
      this.paramKey = res.data[0].paramKey;
      this.centreList = res.data.filter((item) => {
        return item.paramValue;
      });
    },
    // 导出PDF
    exportPDF() {
      html2canvas(this.$refs.card.$el, {
        scale: 2.0,
        useCORS: true,
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/jpeg", 1.0);
        const title = this.year + "年年度成绩表";
        const pdf = new JsPDF("l", "mm", [canvas.width, canvas.height]);
        pdf.addImage(imgUrl, "JPEG", 0, 0, canvas.width, canvas.height);
        pdf.save(title + ".pdf");
      });
    },
    // 打印预览
    Print() {
      html2canvas(this.$refs.card.$el, {
        scale: 2.0,
        useCORS: true,
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/jpeg", 1.0);
        printJS({
          printable: imgUrl,
          type: "image",
          documentTitle: "年度成绩表",
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-card {
  min-height: 600px;
}
.cert-box {
  border: 1px solid #000;
}
.cert-title {
  text-align: center;
  padding: 30px 0;
  h2 {
    font-size: 26px;
    font-weight: 600;
    color: #000;
  }
  .logo-line {
    position: relative;
    width: 60%;
    margin: 20px auto 0;
    img {
      position: relative;
      width: 165px;
      height: 50px;
      z-index: 99;
      background: #fff;
    }
    .line {
      width: 100%;
      border-bottom: 3px dashed #ccc;
      margin-top: -34px;
      z-index: -1;
    }
  }
}
.cert-name {
  padding: 20px 60px;
  p {
    font-size: 18px;
    line-height: 1.6;
  }
  .lab-name {
    text-decoration: underline;
    font-weight: 600;
    margin-right: 4px;
  }
}
.cert-body {
  padding: 30px 60px;
  p {
    font-size: 18px;
    line-height: 2;
    color: #000;
    text-indent: 2em;
  }
  .year-text,
  .level {
    text-decoration: underline;
    font-weight: 600;
  }
}
.cert-detail {
  padding: 20px 60px;
  .detail-title {
    font-size: 18px;
    font-weight: 600;
  }
  .detail-list {
    margin-top: 10px;
    p {
      display: inline-block;
      width: 50%;
      font-size: 15px;
      line-height: 1.8;
    }
  }
}
.seal-area {
  min-height: 160px;
  position: relative;
  .seal-name {
    position: absolute;
    top: 40px;
    left: 75%;
    z-index: 100;
    p {
      margin: 0;
      font-size: 16px;
      line-height: 1.8;
      color: #000;
      white-space: nowrap;
    }
  }
  .seal-img {
    position: absolute;
    left: 77%;
    text-align: center;
    overflow: hidden;
    .seal_inner {
      display: inline-block;
      margin-left: 10px;
      &:nth-of-type(1) {
        margin-left: 0;
      }
      img {
        width: 95px;
        height: 95px;
      }
    }
    &.seal1 {
      width: 100px;
      top: 10px;
    }
    &.seal2 {
      width: 210px;
      top: 15px;
    }
    &.seal3 {
      width: auto;
      top: 20px;
    }
  }
}
.empty-tip {
  text-align: center;
  padding: 80px 0;
  color: #909399;
  i {
    font-size: 48px;
    color: #c0c4cc;
  }
  p {
    margin-top: 20px;
    font-size: 16px;
  }
}
.el-button {
  margin: 30px 0 0 30px;
}
</style>
